module.exports = __webpack_public_path__ + "static/bathroom-dc073472809674072419fb39ad6c6a3b.jpg";